import { Flame, MapPin, AlertTriangle, ListChecks, Phone, MessageSquare, Mail } from "lucide-react";
import { IMG } from "./shared";

const SCOPE = ["Remove damaged carpet & pad", "Treat moisture at north wall", "Install LVP flooring ~650 sq ft"];

export const PhoneMockup = () => (
  <div className="relative mx-auto w-[300px] sm:w-[330px]" data-testid="hero-phone-mockup">
    <div className="absolute -inset-6 -z-10 rounded-[3rem] bg-[color-mix(in_srgb,var(--brand)_18%,transparent)] blur-2xl" />
    <div className="rounded-[2.6rem] border-[10px] border-slate-900 bg-slate-900 shadow-2xl">
      <div className="relative overflow-hidden rounded-[2rem] bg-slate-50">
        <div className="absolute left-1/2 top-2 h-5 w-24 -translate-x-1/2 rounded-full bg-slate-900" />
        <div className="px-4 pb-4 pt-10">
          <div className="flex items-start justify-between">
            <div>
              <p className="font-display text-lg font-bold text-slate-900">Sarah Mitchell</p>
              <p className="flex items-center gap-1 text-xs text-slate-500">Basement Renovation · <MapPin className="h-3 w-3" />Cherry Hill</p>
            </div>
            <span className="inline-flex items-center gap-1 rounded-full border border-rose-200 bg-rose-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-rose-800">
              <Flame className="h-3 w-3" />Hot
            </span>
          </div>
          <div className="mt-3 grid grid-cols-2 gap-1.5">
            <img src={IMG.basement} alt="Basement project" className="h-24 w-full rounded-xl object-cover" />
            <img src={IMG.room} alt="Room project" className="h-24 w-full rounded-xl object-cover" />
          </div>
          <div className="mt-3 rounded-2xl border border-slate-200 bg-white p-3">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">AI preliminary estimate</p>
            <p className="whitespace-nowrap font-display text-xl font-extrabold text-slate-900 sm:text-2xl">$18,500 – $27,000</p>
            <p className="mt-2 flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wider text-slate-500"><ListChecks className="h-3 w-3" />Scope of work</p>
            <ul className="mt-1 space-y-0.5">
              {SCOPE.map((s) => <li key={s} className="text-xs text-slate-700">• {s}</li>)}
            </ul>
            <p className="mt-2 flex items-start gap-1.5 rounded-lg bg-red-50 px-2 py-1.5 text-xs text-red-700">
              <AlertTriangle className="mt-0.5 h-3 w-3 shrink-0" />Possible moisture staining on lower wall
            </p>
          </div>
          <div className="mt-3 flex gap-1.5">
            {[[Phone, "Call", true], [MessageSquare, "Text"], [Mail, "Email"]].map(([Icon, label, primary]) => (
              <span key={label} className={`flex h-11 flex-1 flex-col items-center justify-center rounded-xl text-[10px] font-bold ${
                primary ? "bg-[color:var(--brand)] text-white" : "border border-slate-200 bg-white text-slate-800"}`}>
                <Icon className="h-4 w-4" />{label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  </div>
);
